import React from 'react';
import { Link, graphql, useStaticQuery } from 'gatsby';
import logo from './programmingwithjon2.png'

// import './header.module.scss';
import headerStyles from './header.module.scss';

const Header = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);
  return (
    <header className={headerStyles.header}>
      <>
      <Link to="/" className={headerStyles.titleBar}>
          <img
            src={logo}
            className={headerStyles.logo}
            alt="Programming With Jon Logo"
          />
          <h1 className={headerStyles.title}>{data.site.siteMetadata.title}</h1>
        </Link>
        <nav className={headerStyles.nav}>
          <ul className={headerStyles.navList}>
            <li><Link className={headerStyles.navItem} activeClassName={headerStyles.activeNavItem} to="/">Home</Link></li>
            <li><Link className={headerStyles.navItem} activeClassName={headerStyles.activeNavItem} to="/blog">Blog</Link></li>
            <li><Link className={headerStyles.navItem} activeClassName={headerStyles.activeNavItem} to="/about">About</Link></li>
            <li><Link className={headerStyles.navItem} activeClassName={headerStyles.activeNavItem} to="/contact">Contact Me</Link></li>
          </ul>
        </nav>
      </>
    </header>
  )
}

export default Header;